import React, { Component, Fragment } from 'react'
import { NavLink } from "react-router-dom";
import { IsAuthorize } from '../../../../../shared/authorization/check-access';
import { Role } from '../../../../../shared/authorization/enums';

interface IProps {
    id: number,
    url: string
}
export  class AppletsTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item">
                    {IsAuthorize([Role.TAM, Role.Dev, Role.AM, Role.Support, Role.Manager]) && <NavLink to={"/applet/delete/" + this.props.id} className={this.props.url=="/applet/delete/"?"nav-link active":"nav-link"} id="show-tab" data-toggle="tab" href="#delete" role="tab"
                        aria-controls="delete" aria-selected={this.props.url=="/applet/delete/"?"true":"false"}><i className="far fa-trash-alt"></i>&nbsp;Delete</NavLink>}
                </li>
                    <li className="nav-item">
                        <NavLink to={"/applet/detail/" + this.props.id} className={this.props.url == "/applet/detail/" ? "nav-link active" : "nav-link"} id="edit-tab" data-toggle="tab" href="#edit" role="tab"
                            aria-controls="edit" aria-selected={this.props.url == "/applet/detail/" ? "true" : "false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                    </li>
                </ul>
                <br />
            </Fragment>
        )
    }
}
